/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Non vendere né condividere le mie informazioni personali",
      "Bumble",
      "App",
      "Chi siamo",
      "Lavora con noi",
      "Contattaci",
      "Investitori",
      "Shop",
      "Azienda",
      "Scarica l'app",
      "Accessibilità su Bumble",
      "Regolamento",
      "Preferenze cookie",
      "Modern Slavery Act",
      "Informativa sulla raccolta dati",
      "Informativa sulla privacy",
      "Termini e condizioni",
      "Note legali",
      "Informativa sulla privacy Washington Consumer Health",
      "Scansiona il codice QR per scaricare l'app di Bumble",
      "Disdici i contratti qui",
      "Chiudi menu",
      "Apri menu",
      "Selezione lingua",
      "Piè di pagina",
      "Accessibilità a Bumble",
      "Apple e il logo di Apple sono marchi di Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble",
      "Lavora con noi",
      "Google Play è un marchio di Google LLC.",
      "Linee Guida",
      "Investitori",
      "Preferenze cookie",
      "Dichiarazione sulle leggi contro la schiavitù moderna",
      "Informativa sulla raccolta dati",
      "Informativa sulla privacy",
      "Consigli aggiornati per conoscere gente",
      "Termini & Condizioni",
      "L'app",
      "Informativa sulla privacy Washington Consumer Health",
      "Chi siamo",
      "Ambasciatori",
      "Conosci gente e fai nuove amicizie",
      "Fai networking e coltiva la tua carriera",
      "Trova una relazione o niente di serio, a te la scelta",
      "Blog",
      "Scopri di più",
      "Esplora il mondo con la modalità Travel",
      "Date",
      "Funzionalità",
      "Compliments",
      "Invia dei Compliments per farti notare e distinguerti da tutti.",
      "Scopri",
      "Una pagina personalizzata che evidenzia i profili più compatibili con te, aggiornata ogni giorno",
      "Modalità Incognito",
      "Usa la modalità Incognito per nascondere il tuo profilo da colleghi, parenti o anche ex.",
      "Collegamento rapido",
      "Avete iniziato una conversazione a un evento Bumble dal vivo? Continuatela sull'app.",
      "Opening Moves",
      "Scegli le Opening Moves per invitare i collegamenti ad avviare la conversazione, così non dovrai farlo tu.",
      "Modalità Snooze",
      "Prenditi un momento per te con la modalità Snooze. E quando vuoi tornare a conoscere gente, siamo qui ad aspettarti.",
      "SuperSwipe",
      "Il profilo si fa interessante? Faglielo sapere con un SuperSwipe.",
      "Modalità Travel",
      "Metti nuove conoscenze in valigia e trova gente in tutto il mondo con la modalità Travel.",
      "Videochiamata",
      "Usa le funzioni di videochiamata e chiamata vocale per scoprire se è tempo di organizzare un appuntamento di persona.",
      "Web app",
      "Prova l'esperienza di Bumble direttamente dal tuo browser.",
      "Scarica l'app di Bumble",
      "BFF",
      "Sicurezza",
      "Storie",
      "Assistenza",
      "Shop",
      "Principale",
      "Invia un bel complimento per farti notare.",
      "Compliments",
      "Funzioni pensate per permetterti di coltivare connessioni autentiche, rispettose e profonde.",
      "Nascondi il tuo profilo da colleghi, parenti o anche ex.",
      "Modalità Incognito",
      "Metti in pausa gli incontri con la modalità Snooze.",
      "Modalità Snooze",
      "Hai visto qualcuno che ti piace? Faglielo sapere.",
      "SuperSwipe",
      "Esplora la sezione Appuntamenti",
      "Viaggia per il mondo e fai incontri ovunque ti trovi.",
      "Modalità Travel",
      "Preparati all'incontro reale, chiacchierando dal comfort di casa.",
      "Videochiamate",
      "Le nostre guide ci aiutano a portare i valori di Bumble nelle proprie community locali.",
      "Guide della community",
      "Funzioni pensate per aiutarti a trovare persone compatibili e a connetterti in base ai tuoi interessi.",
      "Organizza un incontro di gruppo o scopri gli eventi locali nelle vicinanze.",
      "Calendario",
      "Esplora BFF",
      "Tutti i suggerimenti e l'ispirazione di cui hai bisogno per aiutarti a trovare amore e nuove amicizie.",
      "Storie e consigli per aiutarti a coltivare le amicizie che desideri.",
      "Centro amicizia",
      "Da Tokyo a Toronto, scopri le storie d'amore di Bumble in tutto il mondo.",
      "Storie d'amore",
      "Organizza l'appuntamento perfetto quando, dove e con chi vuoi.",
      "Consigli per ogni stagione",
      "Esplora la sezione Storie",
      "Leggi tutto",
      "Bumble su {{social_network}}",
      "Contattaci",
      "Accedi",
      "(opens in new window)",
      "Domande frequenti",
      "Cookie Policy",
      "Bumble - The Blog",
      "Lavora con noi",
      "Chat",
      "Città",
      "Preferenze cookie",
      "Copyright © 2006 – presente. Bumble. Tutti i diritti riservati.",
      "Appuntamenti in tutta tranquillità: report",
      "Apple e il logo di Apple sono marchi di Apple Inc.{{__EOL__}}Google Play è un marchio di Google LLC.",
      "Scarica",
      "Facebook",
      "Seguici",
      "AIuto",
      "Instagram",
      "Lingua",
      "LinkedIn",
      "Bumble fa parte di Bumble Inc.",
      "Informativa sulla privacy",
      "Safety Centre",
      "Mappa del sito",
      "Dichiarazione sulle leggi contro la schiavitù moderna",
      "Condizioni d'utilizzo",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "giorni"
            ],
            "singular": [
                  "giorno"
            ]
      },
      "hour": {
            "plural": [
                  "ore"
            ],
            "singular": [
                  "ora"
            ]
      },
      "minute": {
            "plural": [
                  "minuti"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "mesi"
            ],
            "singular": [
                  "mese"
            ]
      },
      "second": {
            "plural": [
                  "secondi"
            ],
            "singular": [
                  "secondo"
            ]
      },
      "year": {
            "plural": [
                  "anni"
            ],
            "singular": [
                  "anno"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
